import React from "react";
import { useSelector } from "react-redux";
import useImage from "use-image";
import { Stage, Layer, Image, Line, Circle, Text } from "react-konva";

export default function OneLineDiagram(props) {
  const {inverterInfo} = props
  const roofInfo = useSelector((state) => state.roof);
  let inverterDetail = []
  const totalConsumption = roofInfo?.value?.financialAnalysis
    ? roofInfo.value.financialAnalysis.tcy
    : 0;
  const structureFacing = "Azimuth Facing";
  inverterDetail = inverterInfo

  const [stringSrc] = useImage("./images/electricalAssets/strings.jpg");
  const [inverterSrc] = useImage("./images/electricalAssets/Inverter.svg");
  const [meter] = useImage("./images/electricalAssets/feedMeter.svg");
  const [meter2] = useImage("./images/electricalAssets/feedMeter2.png");
  const [fixed] = useImage("./images/electricalAssets/fixed.svg");
  const [frame] = useImage("./images/electricalAssets/frame.svg");
  const [grid] = useImage("./images/electricalAssets/Grid.svg");

  return (
    <React.Fragment>
      <Stage
        width={500}
        height={374}
        fill="ghostwhite"
      >
        <Layer strokeWidth={2}>
          {inverterDetail.totalStringMPPT > 3 && (
            <>
              <Text
                x={17}
                y={12}
                text={`${structureFacing}`}
                fontSize={9}
                fill="black"
                strokeWidth={1}
              />
              <Image image={stringSrc} width={50} x={20} y={22} />
              <Text
                x={75}
                y={24}
                text={`1x${inverterDetail.noOfStringMPPT}`}
                fontFamily="italic"
                fontSize={10}
                fill={"black"}
                strokeWidth={1}
              />
              <Line
                points={[68, 35, 110, 35]}
                stroke="black"
                strokeWidth={2}
                dash={[5, 2]}
              />
              <Text
                x={144}
                y={44}
                text={`(1)`}
                fontFamily="italic"
                fontSize={10}
                fill={"black"}
                strokeWidth={1}
              />
              <Image image={stringSrc} width={50} x={108} y={22} />
              <Line
                points={[156, 34, 201, 34]}
                stroke="black"
                strokeWidth={2}
              />
              <Line
                points={[200, 34, 200, 80]}
                stroke="black"
                strokeWidth={2}
              />
              <Line
                points={[199, 80, 220, 80]}
                stroke="black"
                strokeWidth={2}
              />
              <Circle x={220} y={80} radius={4} fill="black" />
            </>
          )}
          {inverterDetail.totalStringMPPT > 0 && (
            <>
              <Text
                x={17}
                y={52}
                text={`${structureFacing}`}
                fontSize={9}
                fill={"black"}
                strokeWidth={1}
              />
              <Image image={stringSrc} width={50} x={20} y={62} />
              <Text
                x={75}
                y={64}
                text={
                  inverterDetail.totalStringMPPT <= 2
                    ? `1x${inverterDetail.lastStringMPPT}`
                    : `1x${inverterDetail.noOfStringMPPT}`
                }
                fontFamily="italic"
                fontSize={10}
                fill={"black"}
                strokeWidth={1}
              />
              <Line
                points={[68, 74, 110, 74]}
                stroke="black"
                strokeWidth={2}
                dash={[5, 2]}
              />
              <Text
                x={144}
                y={85}
                text={
                  inverterDetail.totalStringMPPT <= 2
                    ? `(1)`
                    : `(${inverterDetail.totalStringMPPT - 2})`
                }
                fontFamily="italic"
                fontSize={10}
                fill={"black"}
                strokeWidth={1}
              />
              <Image image={stringSrc} width={50} x={108} y={62} />
              <Line
                points={[156, 74, 190, 74]}
                stroke="black"
                strokeWidth={2}
              />
              <Line
                points={[190, 74, 190, 90]}
                stroke="black"
                strokeWidth={2}
              />
              <Line
                points={[189, 90, 220, 90]}
                stroke="black"
                strokeWidth={2}
              />
              <Circle x={220} y={90} radius={4} fill="black" />
            </>
          )}
          {inverterDetail.totalStringMPPT >= 2 && (
            <>
              <Text
                x={17}
                y={95}
                text={`${structureFacing}`}
                fontSize={9}
                fill={"black"}
                strokeWidth={1}
              />
              <Image image={stringSrc} width={50} x={20} y={105} />
              <Text
                x={75}
                y={105}
                text={
                  inverterDetail.oneLineMethod !== "strings/MPPT"
                    ? `1x${inverterDetail.noOfStringMPPT}`
                    : `1x${inverterDetail.lastStringMPPT}`
                }
                fontFamily="italic"
                fontSize={10}
                fill={"black"}
                strokeWidth={1}
              />
              <Line
                points={[68, 116, 110, 116]}
                stroke="black"
                strokeWidth={2}
                dash={[5, 2]}
              />
              <Text
                x={144}
                y={128}
                text={
                  inverterDetail.totalStringMPPT <= 2
                    ? `(2)`
                    : `(${inverterDetail.totalStringMPPT - 1})`
                }
                fontFamily="italic"
                fontSize={10}
                fill={"black"}
                strokeWidth={1}
              />
              <Image image={stringSrc} width={50} x={108} y={105} />

              <Line
                points={[156, 116, 190, 116]}
                stroke="black"
                strokeWidth={2}
              />
              <Line
                points={[190, 116, 190, 100]}
                stroke="black"
                strokeWidth={2}
              />
              <Line
                points={[189, 100, 220, 100]}
                stroke="black"
                strokeWidth={2}
              />
              <Circle x={220} y={100} radius={4} fill="black" />
            </>
          )}
          {inverterDetail.totalStringMPPT >= 3 && (
            <>
              <Text
                x={17}
                y={136}
                text={`${structureFacing}`}
                fontSize={9}
                fill={"black"}
                strokeWidth={1}
              />
              <Image image={stringSrc} width={50} x={20} y={147} />
              <Text
                x={75}
                y={148}
                text={`1x${inverterDetail.lastStringMPPT}`}
                fontFamily="italic"
                fontSize={10}
                fill={"black"}
                strokeWidth={1}
              />
              <Line
                points={[68, 158, 110, 158]}
                stroke="black"
                strokeWidth={2}
                dash={[5, 2]}
              />
              <Text
                x={144}
                y={170}
                text={`(${inverterDetail.totalStringMPPT})`}
                fontFamily="italic"
                fontSize={10}
                fill={"black"}
                strokeWidth={1}
              />
              <Image image={stringSrc} width={50} x={108} y={147} />
              <Line
                points={[156, 158, 200, 158]}
                stroke="black"
                strokeWidth={2}
              />
              <Line
                points={[200, 158, 200, 110]}
                stroke="black"
                strokeWidth={2}
              />
              <Line
                points={[199, 110, 220, 110]}
                stroke="black"
                strokeWidth={2}
              />
              <Circle x={220} y={110} radius={4} fill="black" />
            </>
          )}
        </Layer>
        <Layer>
          {inverterDetail.totalStringMPPT > 4 && (
            <Line
              points={[88, 38, 88, 64]}
              stroke="black"
              strokeWidth={1}
              dash={[1, 3]}
            />
          )}
          {inverterDetail.noOfInverter > 0 && (
            <>
              <Image image={inverterSrc} width={50} x={218} y={68} />
              <Text
                x={270}
                y={98}
                text={`(1)`}
                fontFamily="italic"
                fontSize={10}
                fill={"black"}
                strokeWidth={1}
              />
            </>
          )}

          <Line points={[266, 95, 450, 95]} stroke="black" strokeWidth={2} />
          {roofInfo.value.inverterAnalysis.powerSensor !==
            "No Power Sensor" && (
            <Image image={meter} width={38} height={48} x={310} y={60} />
          )}
          <Image image={meter2} width={37} height={48} x={370} y={60} />
          <Circle x={358} y={95} radius={6} fill="black" />
          <Image image={fixed} width={32} height={28} x={412} y={80} />
          <Image image={grid} width={32} height={28} x={450} y={80} />
          <Line points={[358, 95, 358, 180]} stroke="black" strokeWidth={2} />
          <Line points={[358, 180, 385, 180]} stroke="black" strokeWidth={2} />
          {inverterDetail.errorShow && (
            <Text
              x={360}
              y={200}
              text={`(${inverterDetail.error})`}
              fontFamily="italic"
              fontSize={12}
              fill={"Red"}
              strokeWidth={1}
              width={120}
            />
          )}
          <Image image={frame} width={32} height={32} x={384} y={162} />
          <Text
            x={418}
            y={168}
            text={`Consumption(${totalConsumption}KWh)`}
            fontFamily="italic"
            fontSize={10}
            fill={"black"}
            strokeWidth={1}
            width={54}
          />
        </Layer>

        {inverterDetail.noOfInverter > 1 && (
          <Layer>
            {inverterDetail.actualString > 3 && (
              <>
                <Text
                  x={17}
                  y={193}
                  text={`${structureFacing}`}
                  fontSize={9}
                  fill={"black"}
                  strokeWidth={1}
                />
                <Image image={stringSrc} width={50} x={20} y={203} />
                <Text
                  x={75}
                  y={205}
                  text={`1x${inverterDetail.actualStringMPPT}`}
                  fontFamily="italic"
                  fontSize={10}
                  fill={"black"}
                  strokeWidth={1}
                />
                <Line
                  points={[68, 215, 108, 215]}
                  stroke="black"
                  strokeWidth={2}
                  dash={[5, 2]}
                />
                <Text
                  x={144}
                  y={225}
                  text={`(1)`}
                  fontFamily="italic"
                  fontSize={10}
                  fill={"black"}
                  strokeWidth={1}
                />
                <Image image={stringSrc} width={50} x={108} y={203} />
                <Line
                  points={[156, 215, 200, 215]}
                  stroke="black"
                  strokeWidth={2}
                />
                <Line
                  points={[200, 215, 200, 265]}
                  stroke="black"
                  strokeWidth={2}
                />
                <Line
                  points={[199, 265, 220, 265]}
                  stroke="black"
                  strokeWidth={2}
                />
                <Circle x={220} y={265} radius={4} fill="black" />
              </>
            )}
            {inverterDetail.actualString > 0 && (
              <>
                <Text
                  x={17}
                  y={233}
                  text={`${structureFacing}`}
                  fontSize={9}
                  fill={"black"}
                  strokeWidth={1}
                />
                <Image image={stringSrc} width={50} x={20} y={243} />
                <Text
                  x={75}
                  y={243}
                  text={`1x${inverterDetail.actualStringMPPT}`}
                  fontFamily="italic"
                  fontSize={10}
                  fill={"black"}
                  strokeWidth={1}
                />
                <Line
                  points={[68, 253, 108, 253]}
                  stroke="black"
                  strokeWidth={2}
                  dash={[5, 2]}
                />
                <Text
                  x={144}
                  y={265}
                  text={inverterDetail.totalStringMPPT <= 2 ? `(1)` : `(2)`}
                  fontFamily="italic"
                  fontSize={10}
                  fill={"black"}
                  strokeWidth={1}
                />
                <Image image={stringSrc} width={50} x={108} y={243} />
                <Line
                  points={[156, 253, 190, 253]}
                  stroke="black"
                  strokeWidth={2}
                />
                <Line
                  points={[190, 253, 190, 273]}
                  stroke="black"
                  strokeWidth={2}
                />
                <Line
                  points={[189, 273, 220, 273]}
                  stroke="black"
                  strokeWidth={2}
                />
                <Circle x={220} y={273} radius={4} fill="black" />
              </>
            )}
            {inverterDetail.actualString > 4 && (
              <Line
                points={[88, 254, 88, 302]}
                stroke="black"
                strokeWidth={1}
                dash={[1, 3]}
              />
            )}
            {inverterDetail.actualString >= 2 && (
              <>
                <Text
                  x={17}
                  y={278}
                  text={`${structureFacing}`}
                  fontSize={9}
                  fill={"black"}
                  strokeWidth={1}
                />
                <Image image={stringSrc} width={50} x={20} y={288} />
                <Text
                  x={75}
                  y={290}
                  text={`1x${inverterDetail.actualStringMPPT}`}
                  fontFamily="italic"
                  fontSize={10}
                  fill={"black"}
                  strokeWidth={1}
                />
                <Line
                  points={[68, 300, 108, 300]}
                  stroke="black"
                  strokeWidth={2}
                  dash={[5, 2]}
                />
                <Text
                  x={144}
                  y={310}
                  text={
                    inverterDetail.totalStringMPPT <= 2
                      ? `(2)`
                      : `(${inverterDetail.actualString - 1})`
                  }
                  fontFamily="italic"
                  fontSize={10}
                  fill={"black"}
                  strokeWidth={1}
                />
                <Image image={stringSrc} width={50} x={108} y={288} />

                <Line
                  points={[156, 300, 190, 300]}
                  stroke="black"
                  strokeWidth={2}
                />
                <Line
                  points={[190, 300, 190, 281]}
                  stroke="black"
                  strokeWidth={2}
                />
                <Line
                  points={[189, 281, 220, 281]}
                  stroke="black"
                  strokeWidth={2}
                />
                <Circle x={220} y={281} radius={4} fill="black" />
              </>
            )}
            {inverterDetail.actualString >= 3 && (
              <>
                <Text
                  x={17}
                  y={318}
                  text={`${structureFacing}`}
                  fontSize={9}
                  fill={"black"}
                  strokeWidth={1}
                />
                <Image image={stringSrc} width={50} x={20} y={328} />
                <Text
                  x={75}
                  y={330}
                  text={`1x${inverterDetail.actualStringMPPT}`}
                  fontFamily="italic"
                  fontSize={10}
                  fill={"black"}
                  strokeWidth={1}
                />
                <Line
                  points={[68, 340, 108, 340]}
                  stroke="black"
                  strokeWidth={2}
                  dash={[5, 2]}
                />
                <Text
                  x={142}
                  y={351}
                  text={`(${inverterDetail.actualString})`}
                  fontFamily="italic"
                  fontSize={10}
                  fill={"black"}
                  strokeWidth={1}
                />
                <Image image={stringSrc} width={50} x={108} y={328} />
                <Line
                  points={[158, 340, 200, 340]}
                  stroke="black"
                  strokeWidth={2}
                />
                <Line
                  points={[200, 340, 200, 290]}
                  stroke="black"
                  strokeWidth={2}
                />
                <Line
                  points={[200, 290, 220, 290]}
                  stroke="black"
                  strokeWidth={2}
                />
                <Circle x={220} y={289} radius={4} fill="black" />
              </>
            )}
            <Image image={inverterSrc} width={50} x={218} y={251} />
            <Text
              x={270}
              y={280}
              text={
                inverterDetail.noOfInverter > 2
                  ? `(From2 - ${inverterDetail.noOfInverter})`
                  : `(${inverterDetail.noOfInverter})`
              }
              fontFamily="italic"
              fontSize={10}
              width={90}
              fill={"black"}
              strokeWidth={1}
            />
            <Line
              points={[266, 276, 300, 276]}
              stroke="black"
              strokeWidth={2}
            />
            <Line points={[300, 277, 300, 95]} stroke="black" strokeWidth={2} />
            <Circle x={300} y={95} radius={6} fill="black" />
            {inverterDetail.noOfInverter > 1 && (
              <Line
                points={[245, 120, 245, 252]}
                stroke="black"
                strokeWidth={2}
                dash={[2, 2]}
              />
            )}
          </Layer>
        )}
      </Stage>
    </React.Fragment>
  );
}
